import { Helmet } from "react-helmet-async";

export default function SeoHelmet({ seo }) {
  if (!seo) return null;

  return (
    <Helmet>
      <title>{seo.title}</title>

      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots || "index,follow"} />

      {seo.keywords?.length > 0 && (
        <meta name="keywords" content={seo.keywords.join(", ")} />
      )}

      {seo.canonicalUrl && <link rel="canonical" href={seo.canonicalUrl} />}

      <meta property="og:type" content={seo.openGraph?.type || "website"} />

      <meta
        property="og:site_name"
        content={seo.openGraph?.siteName || "Teamstar"}
      />

      <meta property="og:title" content={seo.openGraph?.title || seo.title} />

      <meta
        property="og:description"
        content={seo.openGraph?.description || seo.description}
      />

      <meta
        property="og:url"
        content={seo.openGraph?.url || seo.canonicalUrl}
      />

      {seo.openGraph?.image && (
        <meta property="og:image" content={seo.openGraph.image} />
      )}

      {seo.openGraph?.imageWidth && (
        <meta property="og:image:width" content={seo.openGraph.imageWidth} />
      )}

      {seo.openGraph?.imageHeight && (
        <meta property="og:image:height" content={seo.openGraph.imageHeight} />
      )}

      {seo.openGraph?.imageAlt && (
        <meta property="og:image:alt" content={seo.openGraph.imageAlt} />
      )}

      {seo.openGraph?.locale && (
        <meta property="og:locale" content={seo.openGraph.locale} />
      )}

      <meta
        name="twitter:card"
        content={seo.twitter?.card || "summary_large_image"}
      />

      <meta name="twitter:title" content={seo.twitter?.title || seo.title} />

      <meta
        name="twitter:description"
        content={seo.twitter?.description || seo.description}
      />

      {(seo.twitter?.image || seo.openGraph?.image) && (
        <meta
          name="twitter:image"
          content={seo.twitter?.image || seo.openGraph.image}
        />
      )}

      {seo.structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(seo.structuredData)}
        </script>
      )}
    </Helmet>
  );
}
